export default __webpack_public_path__ + "static/media/Orange Spooky Graveyard Halloween Poster.86b6fb16.jpg";